import React, {useEffect, useState} from 'react'
import {useHistory} from "react-router-dom";
import '../base/Theme.css';
import './Deposit.css';
import Input from "../base/input/Input";
import Button from "../base/button/Button";
import Loader from "../base/loader/Loader";
import Toolbar from "../base/toolbar/Toolbar";
import Text from "../base/text/Text";
import Space from "../base/space/Space";
import firebase from 'firebase/app';
import 'firebase/auth';
import {Players} from "../../firebase/Collections";
import {mapToPlayer} from "../../firebase/Mappers";
import {claim} from "../../data/Api";
import CopyBox from "../base/copybox/CopyBox";
import {showError, showSuccess} from "../base/toaster/CustomToaster";
import Back from "../base/back/Back";
import {formatValue} from "../../utils/Formatter";

function Deposit() {
    const history = useHistory();
    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        watchPlayer();
    }, [])

    const watchPlayer = () => {
        firebase.auth().onAuthStateChanged(function (user) {
            if (!user) {
                history.push("/login");
            } else {
                firebase.firestore()
                    .collection(Players.NAME)
                    .doc(user.uid)
                    .onSnapshot((doc) => {
                        const player = mapToPlayer(doc);
                        setPlayer(player);
                    });
            }
        });
    }

    const onRefreshClick = async () => {
        if (player?.tableId) {
            showError("You can't refresh tokens while seating.");
            return;
        }

        setLoading(true);
        try {
            await claim()
            showSuccess("Success.")
        } catch (e) {
            showError(e.response.data);
        }
        setLoading(false);
    }

    const onAddressClick = async () => {
        showSuccess("Copied to clipboard.");
    }

    if (!player || loading) {
        return <div className={"Root"}><Loader/></div>
    }

    return (
        <div className="Root">
            <div className="Content">
                <Toolbar title={"Deposit"} leftButton={<Back/>}/>
                <Text style="DepositDescription"
                      text={"This is the place where you can deposit your Iota tokens to play a game."}/>
                <Space space={8}/>
                <Text style="DepositDescription"
                      text={"Send your tokens to the address generated below using the Firefly wallet. " +
                      "Then press 'Refresh' button and wait until your tokens are loaded."}/>
                <Space space={32}/>
                <Input disabled={true} type="text" text={formatValue(player?.money)}/>
                <Space space={8}/>
                <CopyBox data={player?.address} onClick={onAddressClick}/>
                <Space space={16}/>
                <Button text={"Refresh"} onClick={onRefreshClick}/>
            </div>
        </div>
    );
}

export default Deposit;
